export default "__VITE_ASSET__D9sgQ7w9__"